import { TypedJsonResponse } from "../apiClientUtils";
import {
  LimitSchema,
  MeDetailsDto,
  MeProductAccess,
  ProductDto,
  ReleaseNotesItem,
} from "./legolandApiTypes";

export interface LegolandApiClientConfig {
  baseUrl: string;
  fetcher?: typeof fetch;
}

export function createLegolandApiClient({
  baseUrl,
  fetcher: fetch = window.fetch,
}: LegolandApiClientConfig) {
  function get<T = undefined>(input: RequestInfo, init?: RequestInit) {
    return fetch(input, {
      credentials: "include",
      ...init,
    }) as T extends undefined
      ? Promise<Response>
      : Promise<TypedJsonResponse<T>>;
  }

  return {
    get baseUrl() {
      return baseUrl;
    },

    async getLimitSchemas({ productId }: { productId?: string }) {
      return await get<LimitSchema[]>(
        `${baseUrl}/limits/schemas${productId ? `?productId=${productId}` : ""}`
      );
    },

    async getMeDetails() {
      return await get<MeDetailsDto>(`${baseUrl}/users/self`);
    },

    async getMeProductAccess({ productId }: { productId: string }) {
      return await get<MeProductAccess>(
        `${baseUrl}/users/self/products/${productId}/access`
      );
    },

    async getProducts() {
      return await get<ProductDto[]>(`${baseUrl}/products`);
    },

    async getReleaseNotes({ productId }: { productId: string }) {
      return await get<{ content: ReleaseNotesItem[] }>(
        `${baseUrl}/release-notes/${productId}?size=9999`
      );
    },

    async getLegacyReleaseNotes({ productId }: { productId: string }) {
      return await get<string>(
        `${baseUrl}/products/release-notes/${productId}`
      );
    },
  };
}

export type LegolandApiClient = ReturnType<typeof createLegolandApiClient>;
